import { exhaustiveSwitchWithDefault } from "@faire/web--source/common/exhaustiveSwitchWithDefault";
import React from "react";

import { LoggedInBrandPageProductTile } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/LoggedInBrandPageProductTile";
import {
  SearchProductTile,
  SearchProductTilePrehydrationClickTrackingWrapper,
} from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/SearchProductTile";
import { ProductTileType } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/ProductTileType";
import { ProductTileTypeContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/productTileTypeContext";
import { ILeanProductTile } from "@faire/retailer/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";

import { SDUIEvaluateProductTile } from "./__internal__/SDUIEvaluateProductTile";

const ProductTileBase: React.FC<{
  productTile: ILeanProductTile | undefined;
  productTileType: ProductTileType;
  brand: ILeanProductTile.IBrand | undefined;
  "data-test-id"?: string;
}> = ({ productTile, productTileType, brand, "data-test-id": dataTestId }) => {
  if (productTile === undefined) {
    return null;
  }

  switch (productTileType) {
    case ProductTileType.LAYOUT_ELEMENT:
    case ProductTileType.SEARCH:
      return (
        <ProductTileTypeContext.Provider
          value={{
            productTileType: productTileType,
          }}
        >
          <SearchProductTilePrehydrationClickTrackingWrapper
            productToken={productTile.product?.token ?? ""}
          >
            <SearchProductTile
              productTile={productTile}
              brand={brand}
              data-test-id={dataTestId}
            />
          </SearchProductTilePrehydrationClickTrackingWrapper>
        </ProductTileTypeContext.Provider>
      );
    case ProductTileType.BRAND:
      return (
        <ProductTileTypeContext.Provider
          value={{
            productTileType: ProductTileType.BRAND,
          }}
        >
          <LoggedInBrandPageProductTile
            productTile={productTile}
            data-test-id={dataTestId}
            brand={brand}
          />
        </ProductTileTypeContext.Provider>
      );
    case ProductTileType.SDUI_EVALUATE:
      return (
        <SDUIEvaluateProductTile productTile={productTile} brand={brand} />
      );
    default:
      return exhaustiveSwitchWithDefault(null)(productTileType);
  }
};

export const ProductTile = ProductTileBase;
